import { AppState, DefinitionActionsState, MenuOptionId, MenuOptionRecord } from '@mode/legacy/types-app-state';
import { ClientActionType, ReducerTree } from '@mode/legacy/util-domain';
import { Actions } from '~/actions';

export const initialDefinitionActionsState: DefinitionActionsState = {
  create: new MenuOptionRecord<MenuOptionId.Definition.Create>({
    name: 'New Definition',
    id: MenuOptionId.Definition.Create,
  }),
  delete: new MenuOptionRecord<MenuOptionId.Definition.Delete>({ name: 'Delete', id: MenuOptionId.Definition.Delete }),
  settings: new MenuOptionRecord<MenuOptionId.Definition.Settings>({
    name: 'Settings',
    id: MenuOptionId.Definition.Settings,
  }),
  sync: new MenuOptionRecord<MenuOptionId.Definition.Sync>({
    name: 'Push to GitHub',
    id: MenuOptionId.Definition.Sync,
  }),
  viewGithub: new MenuOptionRecord<MenuOptionId.Definition.ViewGithub>({
    name: 'View in GitHub',
    id: MenuOptionId.Definition.ViewGithub,
  }),
};

function createReducer(
  state = initialDefinitionActionsState.create,
  action: Actions
): Readonly<DefinitionActionsState['create']> {
  switch (action.type) {
    case ClientActionType.LoadAccountSuccess: {
      const granted = true;
      const enabled = true;

      return state.merge({ enabled, granted });
    }
  }

  return state;
}

function deleteReducer(
  state = initialDefinitionActionsState.delete,
  action: Actions
): Readonly<DefinitionActionsState['delete']> {
  switch (action.type) {
    case ClientActionType.LoadAccountSuccess: {
      const granted = true;
      const enabled = true;

      return state.merge({ enabled, granted });
    }
  }

  return state;
}

function settingsReducer(
  state = initialDefinitionActionsState.settings,
  action: Actions
): Readonly<DefinitionActionsState['settings']> {
  switch (action.type) {
    case ClientActionType.LoadAccountSuccess: {
      const granted = true;
      const enabled = true;

      return state.merge({ enabled, granted });
    }
  }

  return state;
}

function syncReducer(
  state = initialDefinitionActionsState.sync,
  action: Actions
): Readonly<DefinitionActionsState['sync']> {
  switch (action.type) {
    case ClientActionType.LoadDefinitionSuccess:
      return state.merge({
        enabled: true,
        granted: action.definitionResource.hasForm('sync_to_github'),
      });
  }

  return state;
}

function viewGithubReducer(
  state = initialDefinitionActionsState.viewGithub,
  action: Actions
): Readonly<DefinitionActionsState['viewGithub']> {
  switch (action.type) {
    case ClientActionType.LoadDefinitionSuccess:
      const link = action.definitionResource.github_link;
      return state.merge({
        enabled: true,
        granted: !!link,
        href: link,
      });
  }

  return state;
}

export const DefinitionActionsReducer: ReducerTree<AppState, DefinitionActionsState, Actions> = {
  create: createReducer,
  delete: deleteReducer,
  settings: settingsReducer,
  sync: syncReducer,
  viewGithub: viewGithubReducer,
};
